import { useState } from 'react';

import { searchABN } from '@funnels/api';
import { FIELD_PATHS } from '@funnels/constants';

import { useDidUpdate } from '../useDidUpdate';
import { useFormValues } from '../useFormValues';

export enum UpdateEmploymentABN {
  EMPTY,
  NOT_FOUND,
  LOADED,
  ERROR,
}

export function useUpdateEmploymentABN(
  employmentIndex: number,
  abn?: string,
  foreignEmployed?: boolean,
  businessName?: string,
  abnGstRegisteredDate?: string
): UpdateEmploymentABN {
  const [, setFormValue] = useFormValues();
  const [abnState, setAbnState] = useState<UpdateEmploymentABN>(UpdateEmploymentABN.EMPTY);

  useDidUpdate(async () => {
    let abnDetails;

    try {
      if (abn) {
        abnDetails = await searchABN(abn);
        setAbnState(abnDetails ? UpdateEmploymentABN.LOADED : UpdateEmploymentABN.NOT_FOUND);
      } else {
        setAbnState(UpdateEmploymentABN.EMPTY);
      }
    } catch (e) {
      setAbnState(UpdateEmploymentABN.ERROR);
      abnDetails = undefined;
    }

    const isABNVerified = abnDetails?.abnStatus && abnDetails?.abnStatus.toUpperCase() === 'ACTIVE';
    setFormValue(FIELD_PATHS.EMPLOYMENT_ABN(employmentIndex), Number(abnDetails?.abn) || undefined);
    setFormValue(FIELD_PATHS.EMPLOYMENT_ABN_VERIFIED(employmentIndex), isABNVerified);
    setFormValue(FIELD_PATHS.EMPLOYMENT_BUSINESS_NAME(employmentIndex), abnDetails?.entityName ?? businessName);
    setFormValue(FIELD_PATHS.EMPLOYMENT_FOREIGN_EMPLOYED(employmentIndex), foreignEmployed);
    setFormValue(FIELD_PATHS.EMPLOYMENT_BUSINESS_STRUCTURE(employmentIndex), abnDetails?.businessType);
    setFormValue(FIELD_PATHS.EMPLOYMENT_PRIVATE_OR_PUBLIC(employmentIndex), abnDetails?.entityType);

    setFormValue(
      FIELD_PATHS.EMPLOYMENT_ABN_GST_REGISTERED_DATE(employmentIndex),
      abnDetails?.gstRegisteredDate ?? abnGstRegisteredDate
    );
  }, [abn, foreignEmployed]);

  return abnState;
}
